import { store } from "../app/store";

export function devModeLog(message?: any, ...optionalParams: any[]) {
	if (store.getState().system.devMode) {
		console.log(message, ...optionalParams);
	}
}
